import REQUEST_STATUS from '../common/REQUEST_STATUS'
import { createSlice } from '@reduxjs/toolkit'
import { submitFormReducer } from '../reducers/submitForm'
import { personFields } from '../common/FORM_SEGMENTS'

export const INITIAL_APPLICATION_DOCUMENT_STATE = {
  path: '',
  name: '',
  data: null,
  pageCount: null,
  productType: null
}

export const initialState = {
  error: undefined,
  status: REQUEST_STATUS.NOT_STARTED,
  data: {
    documents: {
      life: { ...INITIAL_APPLICATION_DOCUMENT_STATE },
      ci: { ...INITIAL_APPLICATION_DOCUMENT_STATE },
      disability: { ...INITIAL_APPLICATION_DOCUMENT_STATE },
      lifeDisability: { ...INITIAL_APPLICATION_DOCUMENT_STATE },
    },
    decision: '',
    straightThroughDecision: '',
    applicant: personFields,
    straightThroughUnderwritingDecisions: [],
    groupStatus: ''
  }
}

const decisionSlice = createSlice({
  name: 'decision',
  initialState,
  reducers: {},
  extraReducers: {
    ...submitFormReducer
  }
})

export const decisionReducer = decisionSlice.reducer